import { Component, Input } from '@angular/core';
import { Question } from '@core/models/question.model';

@Component({
  selector: 'app-disable-poor-excellent',
  templateUrl: './disable-poor-excellent.component.html',
  styleUrls: ['./disable-poor-excellent.component.css'],
})
export class DisablePoorExcellentComponent {
  @Input() question!: Question;
}
